import { OrderEditingSettingsSchema } from "@redotech/redo-model/order-editing/order-editing-tools";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getAllowedOrderEditTypes = {
  name: "getAllowedOrderEditTypes" as const,
  input: z.object({
    orderId: zExt.objectId(),
  }),
  output: OrderEditingSettingsSchema.optional(),
};
